/* eslint-disable no-console */
import {CrownFilled, FileTextOutlined} from '@ant-design/icons';
import {Breadcrumb, Button, Row} from 'antd';
import React, {useEffect, useState} from 'react';
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import NotFoundPage from '../../../components/ErrorHandling/NotFoundComp/NotFound';
import Loader from '../../../components/Loader/Loader';
import UpgradeButton from '../../../components/UpgradeButton/UpgradeButton';
import {
  frameworkBrsrSource,
  frameworkBrsrSourceTargetCDP,
  frameworkGriSource
} from '../../../constants/FrameworkDataMapping';
import {allRoutes} from '../../../constants/Routes';
import pillarsAPI from '../../../services/modules/ESG/pillarsAPI';
import replicateFrameworkMappingData from '../../../services/modules/ESG/replicateFrameworkMappingData';
// import checkSelectedYear from '../../../shared/checkSelectedYear';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import {checkCurrentYearOrBelow} from '../../../utils/commonFunctions';
import {
  hasAccessToReport,
  shouldBlockReportAccess
} from '../../../utils/SubscriptionHelper';
import {
  addPillarsToFrameworkObj,
  filterFrameworkPillars,
  handleIsComingSoonConditionally
} from '../constants/commonFunctions';
import {frameworkRoute} from '../constants/frameworkRoutes';
import {FrameworkObj} from '../constants/FrameWorksConst';
import {
  GRIObject,
  SASBObject,
  BRSRObject,
  TCFDObject,
  CDPObject,
  CDPCorporateObject,
  CBAMObject
} from '../constants/PillarsConst';

import ConfirmOverrideModal from './ConfirmOverrideModal';
import Pillar from './Pillar';
import PrefillMappingModal from './PrefillMappingModal';

const Pillars: React.FC = () => {
  const {framework} = useParams();
  const [tabRender, setTabRender] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [pillarData, setPillarData] = useState<any[]>([]);
  const companyData = useCompanyStore?.getState().companyDetails;
  const [prefillLabel, setPrefilllable] = useState('');
  const [isDataMappingModalOpen, setIsDataMappingModalOpen] = useState(false);
  const [frameworkMappingData, setFrameworkMappingData] = useState<any>({});
  const [refresing, setRefresing] = useState<boolean>();
  const [refreshPage, setRefreshPage] = useState(false);
  const [expandedPillarIndex, setExpandedPillarIndex] = useState<number | null>(
    null
  );
  const [openConfirm, setOpenConfirm] = useState(false);

  const pillars = useJSONStore?.getState().esgPillars;

  const handlePillarToggle = (index: number) => {
    setExpandedPillarIndex(expandedPillarIndex === index ? null : index);
  };

  const selectedYear = checkCurrentYearOrBelow(
    searchParams.get('selectedYear')
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (selectedYear) {
      searchParams.set('selectedYear', selectedYear);
      setSearchParams(searchParams);
      if (!location?.state) {
        setIsLoading(true);
        pillarsAPI(selectedYear, true)
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, [selectedYear, refreshPage]);

  useEffect(() => {
    setPillarData(
      location?.state ?? filterFrameworkPillars(pillars, framework)
    );
    if (framework === frameworkRoute.GRI) {
      setTabRender(GRIObject);
      setPrefilllable('Prefill from BRSR');
    } else if (framework === frameworkRoute.SASB) {
      setTabRender(
        SASBObject.filter((item) => {
          return item.category === companyData?.category;
        })
      );
    } else if (framework === frameworkRoute.BRSR) {
      setTabRender(BRSRObject);
      setPrefilllable('Prefill from GRI');
    } else if (framework === frameworkRoute.TCFD) {
      setTabRender(TCFDObject);
    } else if (framework === frameworkRoute.CDP_SME) {
      setTabRender(CDPObject);
      setPrefilllable('Prefill from BRSR');
    } else if (framework === frameworkRoute.CDP_CORPORATE) {
      setTabRender(CDPCorporateObject);
    } else if (framework === frameworkRoute.CBAM) {
      setTabRender(CBAMObject);
    } else {
      setTabRender([]);
    }
  }, [framework]);

  useEffect(() => {
    setPillarData(filterFrameworkPillars(pillars, framework));
  }, [pillars]);

  const preFillHandleRefreshClick = () => {
    let sourceFramework = '';
    let targetFramework = '';
    if (framework === frameworkRoute.BRSR) {
      sourceFramework = frameworkRoute.GRI;
      targetFramework = frameworkRoute.BRSR;
    } else if (framework === frameworkRoute.GRI) {
      sourceFramework = frameworkRoute.BRSR;
      targetFramework = frameworkRoute.GRI;
    } else if (framework === frameworkRoute.CDP_SME) {
      sourceFramework = frameworkRoute.BRSR;
      targetFramework = frameworkRoute.CDP_SME;
    }
    setRefresing(true);
    Promise.all([
      replicateFrameworkMappingData(
        selectedYear?.toString(),
        sourceFramework,
        targetFramework
      )
    ])
      .then(() => {
        setRefreshPage(!refreshPage);
        setIsDataMappingModalOpen(false);
        setOpenConfirm(false);
      })
      .catch(() => {})
      .finally(() => {
        setRefresing(false);
        setIsDataMappingModalOpen(false);
        setOpenConfirm(false);
      });
  };

  const filteredFramework = addPillarsToFrameworkObj(
    useJSONStore?.getState().esgPillars
  );

  const frameworkBrsrGRIColumn = [
    {
      title: `To be shown in ${framework}`,
      dataIndex: 'section',
      key: 'section',
      width: '30%'
    },
    {
      title: `${framework} Questions`,
      dataIndex: 'question',
      key: 'question',
      render: (text: string) => {
        return <div style={{whiteSpace: 'pre-wrap'}}>{text}</div>;
      }
    }
  ];

  const handleFrameworkMappingData = (framework: string) => {
    switch (framework) {
      case frameworkRoute.BRSR:
        setFrameworkMappingData(frameworkBrsrSource());
        break;
      case frameworkRoute.CDP_SME:
        setFrameworkMappingData(frameworkBrsrSourceTargetCDP());
        break;
      default:
        setFrameworkMappingData(frameworkGriSource());
        break;
    }
  };

  return !hasAccessToReport(framework) || shouldBlockReportAccess(framework) ? (
    <NotFoundPage />
  ) : isLoading ? (
    <Loader />
  ) : (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}
      >
        <Breadcrumb
          items={[
            {
              title: (
                <div
                  onClick={() => {
                    navigate({
                      pathname: `${allRoutes.ESG.FRAMEWORK}`,
                      search: location.search
                    });
                  }}
                  style={{
                    cursor: 'pointer'
                  }}
                >
                  Home
                </div>
              )
            },
            {
              title: (
                <div
                  style={{
                    cursor: 'pointer'
                  }}
                >
                  {FrameworkObj?.filter(
                    (i) =>
                      hasAccessToReport(i?.route) &&
                      handleIsComingSoonConditionally(
                        i?.route as frameworkRoute,
                        i?.isComingSoon
                      )
                  )?.find((item) => {
                    return item?.route === framework;
                  })?.shortTitle ?? framework}
                </div>
              ),
              // dropdownProps: {trigger: ['click']},
              menu: {
                items: filteredFramework.map((item) => {
                  if (shouldBlockReportAccess(item.route)) {
                    return {
                      title: (
                        <>
                          {item.route}
                          <CrownFilled
                            style={{color: '#FFD700', paddingLeft: 10}}
                          />
                        </>
                      )
                    };
                  }

                  return {
                    title: (
                      <Link
                        to={`${allRoutes.ESG.FRAMEWORK}/${item.route}${location.search}`}
                        replace={true}
                        state={item?.pillars}
                      >
                        {item?.shortTitle ?? item?.route}
                      </Link>
                    )
                  };
                }),
                getPopupContainer: (triggerNode: any) => triggerNode.parentNode
              },
              dropdownProps: {placement: 'bottomLeft'}
            }
          ]}
          separator="/"
          style={{width: 'max-content', marginBottom: '4px'}}
        />
        {framework === frameworkRoute.BRSR ||
        framework === frameworkRoute.GRI ||
        framework === frameworkRoute.CDP_SME ? (
          shouldBlockReportAccess(
            framework === frameworkRoute.BRSR
              ? frameworkRoute.GRI
              : frameworkRoute.BRSR
          ) ? (
            <UpgradeButton title={prefillLabel} />
          ) : (
            <Button
              type="primary"
              icon={<FileTextOutlined />}
              style={{
                backgroundColor: '#3F5530',
                borderColor: '#3F5530',
                borderRadius: '6px',
                padding: '6px 20px',
                fontWeight: 500
              }}
              onClick={() => {
                handleFrameworkMappingData(framework);
                setIsDataMappingModalOpen(true);
              }}
            >
              {prefillLabel}
            </Button>
          )
        ) : null}
      </div>
      <PrefillMappingModal
        open={isDataMappingModalOpen}
        onCancel={() => {
          setIsDataMappingModalOpen(false);
        }}
        framework={framework ?? ''}
        selectedYear={selectedYear}
        frameworkMappingData={frameworkMappingData}
        columns={frameworkBrsrGRIColumn}
        onConfirm={() => {
          setOpenConfirm(true);
        }}
      ></PrefillMappingModal>
      <ConfirmOverrideModal
        open={openConfirm}
        onConfirm={preFillHandleRefreshClick}
        onCancel={() => {
          setOpenConfirm(false);
        }}
        loading={refresing}
        framework={framework ?? ''}
      ></ConfirmOverrideModal>
      <Row className="row" gutter={16}>
        {tabRender.map((item: any, index: number) => {
          const min =
            tabRender.length <= 3 ? 8 : tabRender.length === 4 ? 6 : 8;

          return (
            <Pillar
              item={item}
              key={index}
              colSpan={min}
              data={
                pillarData?.find((pItem: any) => {
                  return (
                    pItem?.name?.toLowerCase() === item?.title?.toLowerCase()
                  );
                }) ?? {
                  name: '',
                  modules: 0,
                  questionsAnswered: 0,
                  totalQuestions: 0,
                  completion: 0
                }
              }
              isExpanded={expandedPillarIndex === index}
              onToggle={() => {
                handlePillarToggle(index);
              }}
            />
          );
        })}
      </Row>
    </>
  );
};

export default Pillars;
